import { AppContext } from "../core/context";
import { productLibrary } from "../data";
import { AppSettings } from "../settings";
import { Connector, ConnectorInfo, Direction, Entity, Module, Product } from "../types/type_def";
import { ConversionHelper } from "../utils/conversion";
import { getDefaultHeight, getSeriesDepth } from "./construction";
import { handleDragEnd } from "./dragdrop";

export function canInsert(ctx: AppContext, product) {
    return ![148881,148882,157547,157546].includes(product.series);
}

export function getMatchingConnectors(ctx: AppContext, connector: Connector, parentEntity: Entity, childEntity: Entity) {

    const parentConnections = parentEntity.connections.map(x => x.id);
    const childConnections = childEntity.connections.map(x => x.id);

    let adjacentEntities = ctx.entityHelper.getAdjacentEntities(ctx.currentModule, childEntity, ctx.scene);
    const childDirections = adjacentEntities.map(x => x.direction);       
    //const directions = childDirections.filter((x,i,arr) => arr.indexOf(x) === i).sort().toString()       
    //const childMapping = adjacentEntities.map(x => ({ direction: x.direction, category: x.entity.category }))      

    const parentProduct = productLibrary.getProductByProductNo(parentEntity.productNo);
    const childProduct = productLibrary.getProductByProductNo(childEntity.productNo);
  
    let matchingConnectors = [] as Array<string>;

    switch (connector.id) {
        case "CT01_L": {
            matchingConnectors.push("CT04", "CT06", "CT10_R", "CT01_R");
        }
            break;
        case "CT01_R": {
            matchingConnectors.push("CT03", "CT05", "CT10_L", "CT01_L");
        }
            break;
        case "CT03":
        case "CT05":
        case "CT10_L": {    
            
            if ([148882,157547,157546].includes(childProduct.series)) {

                if (childEntity.category === "BACK") {
                    if (!(childDirections.includes("FRONT") && childDirections.includes("RIGHT_FRONT"))) {
                        matchingConnectors.push("CT39"); 
                    } 
                }

                if (childEntity.category === "SEATFRAME") {
                    matchingConnectors.push("CT04","CT39");
                }

            } else if ([148881].includes(childProduct.series)) {                  
                matchingConnectors.push("CT04", "CT11","CT37", "CT03");
            } else {
                matchingConnectors.push("CT04", "CT06", "CT10_R", "CT01_R");
            }            
        }
            break;
        case "CT04":
        case "CT06":
        case "CT10_R": {      
            
            if ([148882,157547,157546].includes(childProduct.series)) {

                if (childEntity.category === "BACK") {
                    if (!(childDirections.includes("FRONT") && childDirections.includes("LEFT_FRONT"))) {
                        matchingConnectors.push("CT38");
                    }
                 }

                if (childEntity.category === "SEATFRAME") {                         
                    matchingConnectors.push("CT03", "CT38"); 
                }  
            } else if ([148881].includes(childProduct.series)) {
                matchingConnectors.push("CT03", "CT11","CT37", "CT04");                   
            } else {
                matchingConnectors.push("CT03", "CT05", "CT10_L", "CT01_L");
            }

        }
            break;             
    
        case "CT11": {
           
            if (!childConnections.includes("CT11") && !childConnections.includes("CT37")) {
                matchingConnectors.push("CT37")
            } 

            if (childConnections.includes("CT37") &&
                !childConnections.includes("CT36")) {
                matchingConnectors.push("CT36")
            } 
            
            if ([148881].includes(childProduct.series)) {                  
                matchingConnectors.push("CT03", "CT11", "CT37", "CT04");                    
            }
                         
        }
            break;
        case "CT36": {
            if (parentEntity.category === "SEATFRAME") {
                if (childConnections.includes("CT37")) {
                    matchingConnectors.push("CT11")
                }     
            }           
        }
            break;
        case "CT37": {
          
            if (!childConnections.includes("CT37") && !childConnections.includes("CT11"))                    
            {
                matchingConnectors.push("CT11")
            }

            if ([148881].includes(childProduct.series)) { 
                matchingConnectors.push("CT03", "CT11", "CT37", "CT04");                     
            }
          
        }
            break;
        case "CT38": {
          
            if ([148882,157547,157546].includes(childProduct.series)) {

                if (childEntity.category === "ARM") {

                    if (!childDirections.includes("RIGHT_BACK") && childConnections.includes("CT44")) {
                        matchingConnectors.push("CT45");
                    } else if (!childDirections.includes("RIGHT") && childConnections.includes("CT44_center")) {
                        matchingConnectors.push("CT45_center");
                    } else if (!childDirections.includes("RIGHT") && !childDirections.includes("RIGHT_BACK")) {
                        matchingConnectors.push("CT45","CT45_center");          
                    }
                  
                } else {                       
                    matchingConnectors.push("CT04","CT39","CT45");

                    if (parentProduct.depth >= 120) {
                         matchingConnectors.push("CT45_center");
                    }
                }  


            } else {                  
                matchingConnectors.push("CT04","CT39","CT45","CT45_center");                    
            }

        }
            break;
        case "CT39": {                    
           
            if ([148882,157547,157546].includes(childProduct.series)) {

                if (childEntity.category === "ARM") {
                
                    if (!childDirections.includes("LEFT_BACK") && childConnections.includes("CT45")) {
                        matchingConnectors.push("CT44");
                    } else if (!childDirections.includes("LEFT") && childConnections.includes("CT45_center")) {
                        matchingConnectors.push("CT44_center");
                    } else if (!childDirections.includes("LEFT") && !childDirections.includes("LEFT_BACK")) {
                        matchingConnectors.push("CT44","CT44_center");          
                    }
                  
                } else {
                    matchingConnectors.push("CT03", "CT38","CT44");   
                    
                    if (parentProduct.depth >= 120) {
                         matchingConnectors.push("CT44_center");
                    }
                }

            } else {  
                matchingConnectors.push("CT03", "CT38","CT44","CT44_center");                    
            }

        }
            break;
        case "CT44_center":           
        case "CT44": {
            matchingConnectors.push("CT39")    
        }
            break;
        case "CT45_center":           
        case "CT45": {
            matchingConnectors.push("CT38")              
        }
            break;

    }

    return matchingConnectors;
}

export function getProximityConnectorInfo(ctx: AppContext, entity: Entity, entityNode: BABYLON.TransformNode): ConnectorInfo[] {
    let matches: Array<{ info: ConnectorInfo; distance: number }> = [];
    let snapDistance = ConversionHelper.scale(80, ctx.scaleFactor) as number;

    entityNode.computeWorldMatrix(true);

    let filteredEntities = ctx.currentModule.entities.filter(function (e) {
        return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" && e.id !== entity.id;
    });

    entity.connectors.forEach(function (connector: Connector) {
        var entityConnector = entityNode.getChildMeshes(false, function (m) { return m.name === connector.id; })[0];
        if (!entityConnector) return;
        entityConnector.computeWorldMatrix(true);
        var entityConnectorPos = entityConnector.getAbsolutePosition();

        filteredEntities.forEach(function (availableEntity: Entity) {
            
            var availableEntityNode = ctx.scene.getTransformNodeByUniqueId(availableEntity.uniqueId);
            if (!availableEntityNode) return;
            availableEntityNode.computeWorldMatrix(true);

            var matchingConnectorIds = getMatchingConnectors(ctx, connector, entity, availableEntity);
            matchingConnectorIds.forEach(function (connectorId: string) {
                if (availableEntity.connections.map(x => x.id).includes(connectorId)) return;
                var matchingConnector = availableEntityNode.getChildMeshes(false, function (m) { return m.name === connectorId; })[0];

                //if (matchingConnector)
                //   console.log(matchingConnector.id +":"+matchingConnector.isEnabled())

                if (!matchingConnector || !matchingConnector.isEnabled()) return;
                matchingConnector.computeWorldMatrix(true);

                var dist = BABYLON.Vector3.Distance(entityConnectorPos, matchingConnector.getAbsolutePosition());

                if (dist <= snapDistance) {
                    var alreadyHasEntity = matches.some(function (m) { return m.info.entityNode.id === availableEntityNode.id; });
                    if (!alreadyHasEntity) {

                       // toggleHighlightConnector(currentModule, availableEntity, matchingConnector, true)
                        //toggleHighlightConnector(currentModule, entity, entityConnector, true)

                        matches.push({
                            info: {
                                entityNode: availableEntityNode as BABYLON.AbstractMesh,
                                connectorNode: matchingConnector,
                                isEnabled: true,
                                sourceConnectorNode: entityConnector
                            } as ConnectorInfo,
                            distance: dist
                        });
                    }
                } 
            });
        });
    });

    matches.sort(function (a, b) { return a.distance - b.distance; });
    return matches.map(function (m) { return m.info; });
}

export function hideConnectors(ctx: AppContext) {
    if (ctx.currentModuleNode) {
        if (ctx.GUI.rootContainer.children.length > 0) {
            ctx.GUI.rootContainer.children.forEach(function (c) {
                if (c.name.indexOf("_connector_") >= 0) {
                    c.alpha = 0;
                    c.isEnabled = false;
                }
            });
        }

        var childmeshes = ctx.currentModuleNode.getChildMeshes(false, function (m) { return BABYLON.Tags.MatchesQuery(m, "connector") });
        childmeshes.forEach(function (m, index) {
            m.setEnabled(false);
        });
    }
}

export function hideAvailableConnectors(ctx: AppContext) {

    if (ctx.currentModuleNode) {
        if (ctx.GUI.rootContainer.children.length > 0) {
            ctx.GUI.rootContainer.children.forEach(function (c) {
                if (c.name.indexOf("_connector_") >= 0) {
                    c.alpha = 0;
                    c.isEnabled = false;
                }
            });
        }

        var childmeshes = ctx.currentModuleNode.getChildMeshes(false, function (m) { return BABYLON.Tags.MatchesQuery(m, "connector") });
        childmeshes.forEach(function (m, index) {
            m.setEnabled(false);
        });
    }
}

export function updateAvailableConnectors(ctx: AppContext, module: Module, entity: Entity) {

    hideAvailableConnectors(ctx);

    const entityNode = ctx.scene.getTransformNodeByUniqueId(entity.uniqueId);
 
    const availableEntities = module.entities.filter(function (e: Entity) {
        return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" && e.id !== entity.id && e.connectors.length > 0
    });
    
    for (let entityConnectors of entity.connectors) {
        const connectorMesh = entityNode.getChildMeshes(false, function (m) { return m.name === entityConnectors.id })[0];
        connectorMesh.computeWorldMatrix(true);
        connectorMesh.setEnabled(true);
    }

    for (let availableEntity of availableEntities) {

        const product = productLibrary.getProductByProductNo(availableEntity.productNo);
        const availableEntityNode = ctx.scene.getTransformNodeByUniqueId(availableEntity.uniqueId);
        const neighborEntities = ctx.entityHelper.getNeighboringEntities(module, availableEntity, ctx.scene);

        for (let connector of availableEntity.connectors) {
            const availableConnectorMesh = availableEntityNode.getChildMeshes(false, function (m) { return m.name === connector.id })[0];
            availableConnectorMesh.computeWorldMatrix(true);
            availableConnectorMesh.setEnabled(true);

            const neighborEntity = neighborEntities.find(x => x.connector.id === connector.id);
            if (neighborEntity) {
                availableConnectorMesh.setEnabled(canInsert(ctx, product));

                 if (neighborEntity.entity.id === entity.id)
                    availableConnectorMesh.setEnabled(true);
            }

          /*  var ray = new BABYLON.Ray(availableConnectorMesh.absolutePosition, availableConnectorMesh.right, 0.5);
            var pickInfo = scene.pickWithRay(ray, x => x.id === "entitybounds" && x.parent && x.parent.id !== availableEntity.id, true);
            if (pickInfo.pickedMesh) {
                if (!availableEntity.connections.map(x => x.entityId).includes(pickInfo.pickedMesh.parent.id))
                    availableConnectorMesh.setEnabled(false);
            } */            
           
        }       
   
    } 
}

export function createEntityConnectors(ctx: AppContext, module: Module, entity: Entity, product: Product, scene: BABYLON.Scene) {

    var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
    var entityBounds = entityNode.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0];

    //Clear connectors
    var connectorNodes = entityNode.getChildMeshes(false, function (c) { return BABYLON.Tags.MatchesQuery(c, "connector") });
    connectorNodes.forEach(function (cn, index) {
        cn.dispose();
        cn = null;
    });
    entity.connectors = [];

    if (entityNode) {

       // let entityConnectionType = moduleHelper.getEntityConnectionType(module, entity);
        let entityBoundingBox = entityBounds.getBoundingInfo().boundingBox;
        let entityConnections = entity.connections.map(x => x.id);
       
        let entityWidth = ConversionHelper.scale(product.width, ctx.scaleFactor) as number;
        var entityDepth = ConversionHelper.scale(product.depth, ctx.scaleFactor) as number;           
        let seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx), ctx.scaleFactor) as number;

        let defaultHeight = ConversionHelper.scale(getDefaultHeight(ctx), ctx.scaleFactor) as number;

        const connectionPointOffset = 0.1

        switch (entity.category) {              

            case "CENTER_SECTION":
            case "CENTER_SECTION_LEFT_SHORTBACK":
            case "CENTER_SECTION_RIGHT_SHORTBACK":
            case "CENTER_SECTION_WO_BACK":
            case "CHAIR": {

                if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 
                if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }

            }
                break;
            case "FOOTSTOOL": {

                if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 

                if (productLibrary.hasProductVariants(product, ["CT04", "CT03"])) {

                    if (!entityConnections.includes("CT10_L")) {
                      //  createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                    }

                    if (!entityConnections.includes("CT10_R")) {
                     //   createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped);
                        createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);                      
                    }                      
                }

                if (productLibrary.hasProductVariants(product, ["CT10"])) {
                     let entityConnectors = entity.connectors.map(x => x.id);

                    if (entityConnectors.includes("CT03") && !entityConnections.includes("CT04") && entityConnections.length > 0) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT10_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                    }
                    if (entityConnectors.includes("CT04") && !entityConnections.includes("CT03") && entityConnections.length > 0) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT10_L", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.LEFT);
                    }
                }


            }
                break;
            case "CLOSING_SECTION_LEFT":
            case "CLOSING_SECTION_LEFT_SHORTBACK":
            case "CLOSING_SECTION_LEFT_WO_ARM": {

                if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 
                if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
                if (productLibrary.hasProductVariants(product, ["CT01", "CT08"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT01_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT05", "CT08"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT05", new BABYLON.Vector3(entityWidth / 2 - seriesDepth / 2, defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.LEFT);
                }

            }
                break;
            case "CLOSING_SECTION_RIGHT":
            case "CLOSING_SECTION_RIGHT_SHORTBACK":
            case "CLOSING_SECTION_RIGHT_WO_ARM": {

                if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 
                if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
                if (productLibrary.hasProductVariants(product, ["CT06", "CT09"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT06", new BABYLON.Vector3(-(entityWidth / 2 - seriesDepth / 2), defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT01", "CT09"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT01_L", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }

            }
                break;
            case "CHAISELONG_LEFT":
            case "CHAISELONG_LEFT_WO_ARM": {

                 if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 
                if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
                if (productLibrary.hasProductVariants(product, ["CT01"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT01_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
            }
                break;
            case "CHAISELONG_RIGHT":
            case "CHAISELONG_RIGHT_WO_ARM":    {

                if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 
                if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
                if (productLibrary.hasProductVariants(product, ["CT01"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT01_L", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
            }
                break;
            case "CORNER_SECTION":
            case "CLOSING_CORNER_SECTION_LEFT":
            case "CLOSING_CORNER_SECTION_RIGHT": {

                if (productLibrary.hasProductVariants(product, ["CT11"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                } 
                if (productLibrary.hasProductVariants(product, ["CT37"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                } 
                if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
                if (productLibrary.hasProductVariants(product, ["CT10"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT10_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                    createEntityConnector(ctx, module, entity, entityNode, "CT10_L", new BABYLON.Vector3(entityWidth / 2 - seriesDepth / 2, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.LEFT);
                }

            }
                break;
            case "SOFA":
            case "SOFA_LEFT":
            case "SOFA_RIGHT":
            case "SOFA_SECTIONAL": {

                if (productLibrary.hasProductVariants(product, ["CT06"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT06", new BABYLON.Vector3(-(entityWidth / 2 - seriesDepth / 2), defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT05"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT05", new BABYLON.Vector3(entityWidth / 2 - seriesDepth / 2, defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.LEFT);
                }
            }
                break;
            case "ARM":
            case "ARM_L":
            case "ARM_R": {

                let armXOffset = 0;

                if ([148882,157547,157546].includes(product.series)) {
                    armXOffset = 0.03;                                            
                }

                var armProducts = productLibrary.productsCategories.find(x => x.type === "ARM");
                armProducts.products.sort((a,b) => a.depth - b.depth);

                if (productLibrary.hasProductVariants(product, ["CT44"])) {
                    seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx, entity, "CT44"), ctx.scaleFactor) as number;
                    createEntityConnector(ctx, module, entity, entityNode, "CT44", new BABYLON.Vector3(entityBoundingBox.extendSize.x+armXOffset, defaultHeight/2, seriesDepth/2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);

                    if (product.depth >= 120) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT44_center", new BABYLON.Vector3(entityBoundingBox.extendSize.x+armXOffset, defaultHeight/2, entityDepth/2), new BABYLON.Vector3(0 ,0, 0), product.isFlipped, Direction.LEFT);     
                    }                
                }
                if (productLibrary.hasProductVariants(product, ["CT45"])) {
                    seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx, entity, "CT45"), ctx.scaleFactor) as number;
                    createEntityConnector(ctx, module, entity, entityNode, "CT45", new BABYLON.Vector3(-(entityBoundingBox.extendSize.x+armXOffset), defaultHeight/2, seriesDepth/2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                   

                    if (product.depth >= 120) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT45_center", new BABYLON.Vector3(-(entityBoundingBox.extendSize.x+armXOffset), defaultHeight/2, entityDepth/2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);   
                    }       
                }  
                
                if (productLibrary.hasProductVariants(product, ["CT04"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                }
                if (productLibrary.hasProductVariants(product, ["CT03"])) {
                    createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                }
            
                                  
            }   
                break;
            case "SEATFRAME": {

                if ([148882,157547,157546].includes(product.series)) {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx, entity, "CT04"), ctx.scaleFactor) as number;
                        createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx, entity, "CT03"), ctx.scaleFactor) as number;
                        createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                    }

                } else {
                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped, Direction.BACK);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped, Direction.FRONT);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                    }
                }
            }   
                break;
            case "BACK": {

                 if ([148882,157547,157546].includes(product.series)) {
                
                    if (productLibrary.hasProductVariants(product, ["CT36"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT36", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI/2, 0), product.isFlipped, Direction.BACK);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI/2, 0), product.isFlipped, Direction.FRONT);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT38"])) {
                        seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx, entity, "CT38"), ctx.scaleFactor) as number;
                        createEntityConnector(ctx, module, entity, entityNode, "CT38", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, (product.depth * ctx.scaleFactor) / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT39"])) {
                        seriesDepth = ConversionHelper.scale(getSeriesDepth(ctx, entity, "CT39"), ctx.scaleFactor) as number;
                        createEntityConnector(ctx, module, entity, entityNode, "CT39", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, (product.depth * ctx.scaleFactor) / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                    }

                } else {
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, Math.PI, 0), product.isFlipped, Direction.RIGHT);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(ctx, module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped, Direction.LEFT);
                    }
                }
                
            }   
                break;
            default: {
            }
                break;
        }
    }
}

export function createEntityConnector(ctx: AppContext, module: Module, entity: Entity, entityNode: BABYLON.TransformNode, connectorName: string, position: BABYLON.Vector3, rotation: BABYLON.Vector3, isFlipped: boolean, direction?: Direction) {

    if (entity.connectors.filter(function (connector) { return connector.id === connectorName }).length === 0) {
        var connectorNode = BABYLON.Mesh.CreateBox(connectorName, ctx.connectorNodeSize, ctx.scene);
        connectorNode.id = entity.id + "_" + connectorName;
        connectorNode.visibility = 0;

        connectorNode.position = position;
        connectorNode.rotation = rotation;
        connectorNode.parent = entityNode;
        connectorNode.metadata = {}
        connectorNode.metadata.meshtype = "connector";          
        connectorNode.metadata.marker = module.id + "_" + entity.id + "_connector_" + connectorName;
        connectorNode.isPickable = true;

        var connectorMarker = new BABYLON.GUI.Image(module.id + "_" + entity.id + "_connector_" + connectorName, AppSettings.Paths.LinkIcon);
        connectorMarker.width = "48px";
        connectorMarker.height = "48px";
        connectorMarker.autoScale = false;
        connectorMarker.metadata = {}
        connectorMarker.metadata.connector = entity.id + "_" + connectorName;
        connectorMarker.alpha = 0;

        connectorMarker.onPointerClickObservable.add(function (data, state) {
            if (ctx.isPlacing) {
                ctx.screenPointerPosition = new BABYLON.Vector2(ctx.scene.pointerX, ctx.scene.pointerY);
                //showLoadingCanvas();
                handleDragEnd(ctx);
            }
        });
        connectorMarker.onPointerEnterObservable.add(function (data, state) {
            if (ctx.isPlacing) {
                connectorMarker.alpha = 0.6;
            }
        });
        connectorMarker.onPointerOutObservable.add(function (data, state) {
            if (ctx.isPlacing) {
                connectorMarker.alpha = 1;
            }
        });

        ctx.GUI.addControl(connectorMarker);
        connectorMarker.linkWithMesh(connectorNode);

        BABYLON.Tags.EnableFor(connectorNode);
        BABYLON.Tags.AddTagsTo(connectorNode, "connector");

        entity.connectors.push({ id: connectorName, position: position, rotation: rotation, normal: new BABYLON.Vector3(0, 0, 1), direction: direction } as Connector);
    }
}

export function getConnectedConnectorInfo(ctx: AppContext, entity: Entity) {

    let connectors = [];

    let entityNode = ctx.scene.getTransformNodeByUniqueId(entity.uniqueId);
    if (entityNode) {

        //Iterate entity connections
        entity.connections.forEach(function (cn) {

            let connectedEntity = ctx.moduleHelper.getEntityByID(ctx.currentModule, cn.entityId) as Entity;
            if (connectedEntity) {

                //Connected entity node
                let connectedEntityNode = ctx.scene.getTransformNodeByUniqueId(connectedEntity.uniqueId);
                var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === entity.id });
                if (connectedEntityConnection) {
                    var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === connectedEntityConnection.id });
                    var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectedEntityConnector.id })[0];
                    connectors.push({ mesh: connectedEntityNode, connector: connectedEntityConnectorNode, weight: 0 });
                }
            }
        });
    }

    return connectors;
}

export function removeEntityConnections(ctx: AppContext, entity: Entity) {

    if (entity) {

        //Is connected?
        if (entity.connections.length > 0) {

            let connectedEntityIds = [];

            for (var c = 0; c < entity.connections.length; c++) {

                let con = entity.connections[c];

                var connectedEntity = ctx.currentModule.entities.find(function (x) { return x.id === con.entityId });
                if (connectedEntity) {
                    connectedEntity.connections.forEach(function (ec) {
                        if (ec.entityId === entity.id) {
                            connectedEntityIds.push(connectedEntity.id);
                            var index = connectedEntity.connections.indexOf(ec);
                            connectedEntity.connections.splice(index, 1);
                        }
                    });
                }
            }

            entity.connections = entity.connections.filter(function (x) { return connectedEntityIds.indexOf(x.entityId) === -1 });
        }
    }
}
